const shaka = require('external/shaka-player.ui.debug');

const TextTitles = class extends shaka.ui.Element {
  private h1Title_ = document.createElement('h1');
  private h2Title_ = document.createElement('h2');

  constructor(parent: typeof TextTitles, controls: { dispatchEvent: (event: Event) => void }) {
    super(parent, controls);

    // The actual container that will be displayed
    this.container_ = document.createElement('div');
    this.container_.classList.add('shaka-text-text-titles');
    this.container_.appendChild(this.h1Title_);
    this.container_.appendChild(this.h2Title_);

    this.parent.appendChild(this.container_);

    setTimeout(() => {
      controls.dispatchEvent(new shaka.util.FakeEvent('titlesComponentInitialized', { component: this }));
    });
  }

  setPrimaryTitle = (title: string): void => {
    this.h1Title_.textContent = title;
  };

  setSecondaryTitle = (title: string): void => {
    this.h2Title_.textContent = title;
  };
};

// Factory that will create a button at run time.
TextTitles.Factory = class {
  create(rootElement, controls) {
    return new TextTitles(rootElement, controls);
  }
};

export default TextTitles;
